import * as z from 'zod';
import { getRouteApi, useSearch } from '@tanstack/react-router';

import { ModeType, modeTypeSchema } from './Home.context';
import { useEffect, useState } from 'react';

const routeApi = getRouteApi('/');

export type Sections = z.infer<typeof modeTypeSchema>;

export const sectionSchema = z.union([modeTypeSchema, z.undefined()]);

export type SectionSchema = z.infer<typeof sectionSchema>;

export const homeSearchSchema = z.object({
	section: sectionSchema,
});

export type HomeSearch = z.infer<typeof homeSearchSchema>;

export function useMode(): ModeType | undefined {
	const [mode, setMode] = useState<ModeType>();
	const homeSearch: HomeSearch = routeApi.useSearch();
	const { section } = homeSearch;
	console.log(`IN THE HOOK: `, homeSearch);
	useEffect(() => {
		if (
			section === 'library' ||
			section === 'daily-news' ||
			section === 'top-stories'
		) {
			setMode(section);
			return;
		}

		setMode('magazines');
	}, [section]);

	return mode;
}
